import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { SUPPORT_EMAIL } from '@/lib/constants';

interface ErrorModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  title: string;
  description: string;
}

export const ErrorModal = ({ isOpen, setIsOpen, title, description }: ErrorModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p>{description}</p>

        <p>
          For help, reach out to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </p>
      </DialogContent>
    </Dialog>
  );
};
